module.exports = __webpack_public_path__ + "static/media/benefit-dashboard.2632b4ca.svg";